import { URLServiceComponent } from './URLServiceComponent';
export const OAuthReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: URLServiceComponent
};